import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  root: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    //
    width: "100%",
    // height: '350px',
    // height: "360px",
    borderRadius: "3px",
    backgroundColor: "#FFFFFF",
  },
  submit: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: "10px",
    paddingRight: "10px",
  },
  submitButton: {
    backgroundColor: "#4D1277",
    borderRadius: "3px",
    fontFamily: "poppins",
    fontSize: "12px",
    fontWright: "500",
    lineHeight: "18px",
    color: "#FFFFFF",
    textTransform: "capitalize",
    boxShadow: "none",
  },
  cancelBtn: {
    backgroundColor: "#9999993d",
    border: "1px solid #9999993d",
    color: "#272525",
    borderRadius: "3px",
    fontFamily: "poppins",
    fontSize: "12px",
    fontWright: "500",
    lineHeight: "18px",
    textTransform: "capitalize",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#9999993d",
      border: "1px solid #9999993d",
      color: "#272525",
    },
  },
  progress: {
    marginLeft: "3px",
    width: "25px",
    height: "25px",
    fontWeight: "400",
    color: "#4d1277",
  },
  name: {
    fontFamily: "poppins",
    fontWeight: "500",
    fontSize: "12px",
    lineHeight: "18px",
    marginTop: 0,
    color: "#272525",
  },
  image: {
    width: "30px",
    height: "30px",
    marginLeft: "10px",
    marginRight: "5px",
    marginTop: "5px",
    marginBottom: "5px",
  },
  loadMoreData: {
    marginTop: "10px",
    height: "340px",
    overflowY: "auto",
  },
  fieldStyle: {
    width: "100%",
    height: "100%",
    color: "#838383",
    fontSize: 12,
    fontWeight: 400,
  },
  selectAll: {
    fontFamily: "poppins",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "17px",
    color: "#838383",
    position: "relative",
    top: "-2px",
    marginLeft: "5px",
  },
  error: {
    width: "100%",
    fontFamily: "poppins",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "red",
    marginTop: "0px",
  },
  divider: {
    width: "100%",
    marginTop: "10px",
    color: "#E8E8E8",
  },
  icon: {
    // height: '10.8px',
    // width: '10.8px',
    height: "18.8px",
    width: "18.8px",
    color: "#B9B9B9",
    marginTop: "13.61px",
    marginRight: "13.6px",
    cursor: "pointer",
  },
  agents: {
    width: "100%",
    height: "21px",
    fontWeight: "500",
    fontFamily: "poppins",
    fontSize: "14px",
    lineHeight: "21px",
    color: "#272525",
    marginTop: "10px",
    marginLeft: "20px",
    //
    display: "flex",
    justifyContent: "center",
  },
}));
export default useStyles;
